// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"158":"c4d8f17b","702":"0fec2f5e"}[chunkId] + ".chunk.css";
};